module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai766-35c79603d0f441e0b92fcec54911ddb5.jpg";